import { utils, writeFile } from 'xlsx'
import type { WritingOptions } from 'xlsx'
import type { PivotMatrix } from './types'
import { PIVOT_PRINT_STYLE } from './constants'
import { PivotExportFormatEnum } from './PivotExportFormatEnum'

// writeFile's WritingOptions omits rawNumbers, but the CSV writer reads it at runtime
// (node_modules/xlsx/xlsx.js:24037) to emit a number cell's v instead of its z-formatted text
type PivotWriteOptions = WritingOptions & { rawNumbers: boolean }

/** Downloads a pivot matrix as an xlsx or csv file. */
export const downloadPivot = (matrix: PivotMatrix, fileName: string, format: PivotExportFormatEnum): void => {
  const workbook = utils.book_new()
  utils.book_append_sheet(workbook, utils.aoa_to_sheet(matrix), 'Pivot')
  const options: PivotWriteOptions = {
    bookType: format === PivotExportFormatEnum.Csv ? 'csv' : 'xlsx',
    rawNumbers: format === PivotExportFormatEnum.Csv,
  }
  writeFile(workbook, `${fileName}.${format}`, options)
}

/** Prints a pivot matrix through a hidden iframe — the focus-then-`print()` sequence of `printIframe` in `HtmlViewer`, on a `srcdoc` built from the matrix. */
export const printPivot = (matrix: PivotMatrix, iframe: HTMLIFrameElement): void => {
  iframe.onload = () => {
    if (iframe.contentWindow) {
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
    }
  }
  iframe.srcdoc = `${PIVOT_PRINT_STYLE}${utils.sheet_to_html(utils.aoa_to_sheet(matrix))}`
}
